import {OnInit} from '@angular/core';
import {FeatureTypeService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {Feature} from '@catcore/services/feature/feature';
import {EntitySchemaType} from '@catcore/utils/json-schema/entity-schema-to-json-schema';
import {buildRouteCommandsForEntities} from '@catfeatures/shared/utils';
import {LinkItem} from '@catui/types';
import {isNullOrUndefined} from 'util';

export abstract class DefaultLanding implements OnInit {

  selfTitle = 'Feature Fixed Routes';
  labels = {
    welcomeTitle: 'Welcome',
    availableItems: `Available ${this.selfTitle}`,
  };

  relatedEntities: LinkItem[];
  availableItems: LinkItem[];

  constructor(private schemaService: EntitySchemaService,
              private featureService: FeatureTypeService) {
  }

  abstract getEntitySchemaTypeRef(): string;

  abstract getRelatedItems(feature: Feature): any[];

  protected setSelfTitle(value: string): void {
    this.selfTitle = value;
    this.labels.availableItems = `Available ${this.selfTitle}`;
  }

  getFeatureService() {
    return this.featureService;
  }

  ngOnInit(): void {
    this
      .featureService
      .getCurrent()
      .subscribe((feature: Feature) => {
        if (!isNullOrUndefined(feature)) {
          const relatedEntities = this.schemaService
            .getRelatedEntitiesFor(EntitySchemaType[this.getEntitySchemaTypeRef()]);
          this.relatedEntities = buildRouteCommandsForEntities(relatedEntities, feature);
          this.availableItems = [];

          this.getRelatedItems(feature).forEach((item) => {

            const queryParams = {resource: item.href};

            this.availableItems.push({
              label: item.label,
              navigate: (router) => {
                router.navigate(['features', feature.id.toString(), 'resource'], {queryParams});
              },
            });
          });

        }
      });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/shared/default-landing.ts